// Sportsbooks a Slip Builder bet can be labeled with: the same list, order and colors as the backend
// (internal/slips/books.go) and the studio's picks card.
export interface Book {
  name: string;
  color: string;
  /** Dark dots get a ring so they show on dark backgrounds. */
  ring?: boolean;
}

export const BOOKS: Book[] = [
  { name: 'Caesars', color: '#1b1b1b', ring: true },
  { name: 'theScore', color: '#3FB950' },
  { name: 'Fanatics', color: '#E5484D' },
  { name: 'DraftKings', color: '#F0883E' },
  { name: 'FanDuel', color: '#3B82F6' },
  { name: 'BetMGM', color: '#C9A227' },
  { name: 'bet365', color: '#0E7C5A', ring: true },
  { name: 'ESPN BET', color: '#A371F7' },
  { name: 'Other', color: '#8B949E' },
];

/** The list's entry for a book name (as saved or detected), if it's on the list. */
export const bookFor = (name?: string): Book | undefined => BOOKS.find((b) => b.name === name);

const ALIASES: Record<string, string> = {
  caesars: 'Caesars',
  caesarssportsbook: 'Caesars',
  williamhill: 'Caesars',
  thescore: 'theScore',
  thescorebet: 'theScore',
  fanatics: 'Fanatics',
  fanaticssportsbook: 'Fanatics',
  draftkings: 'DraftKings',
  draftkingssportsbook: 'DraftKings',
  fanduel: 'FanDuel',
  fanduelsportsbook: 'FanDuel',
  betmgm: 'BetMGM',
  mgm: 'BetMGM',
  bet365: 'bet365',
  espnbet: 'ESPN BET',
  espn: 'ESPN BET',
};

/** A book name as read off a screenshot ("BETMGM", "DraftKings Sportsbook") as the list spells it, or undefined when
 * it isn't one of the listed books. */
export const normalizeBook = (name?: string): string | undefined =>
  name ? ALIASES[name.toLowerCase().replace(/[^a-z0-9]/g, '')] : undefined;
